import { render, staticRenderFns } from "./UserAuthorizationDocuments.vue?vue&type=template&id=31a1080c&"
import script from "./UserAuthorizationDocuments.vue?vue&type=script&lang=js&"
export * from "./UserAuthorizationDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports